import { HttpClient, JSON_STRING, MHTTPCL } from "../../../../services/http/http-client";
import { BOOKING_URL, BOOKINGS_STRING, TRAVEL_URL, MODIFICATION_URL } from "../booking-service";
import { createTravel } from "../../models/travel.model";

const CALENDAR_BOOKINGS_TRAVEL_DETAILS = 'calendar_bookings_travel_details';
const TRAVEL_ID_STRING = 'travel_id';
const COSTS_STRING = 'costs';
const TRAVELS_STRING = 'travels';
const CONFIRMED_FLAG = 'confirmed_flag';
const GET_FLIGHT_INFO = 'get_flight_info';
const ADD_REMOVE_TRAVEL_STEP = 'add_remove_travel_step';
const REMOVE_TRAVEL_STEP = 'remove_travel_step';
const TRAVEL_STEP_FORM = 'travel_step_form';
const ADD_REMOVE_TRAVEL_STEP_CONTACTS = 'add_remove_travel_step_contacts';
const RECORD_STRING = 'record';
export const travelDetailsService = {
	copyArtistContactsToTravelContacts: ({calendar_date_id}) => HttpClient.get(BOOKING_URL, {
    section: 'bookings',
    action: 'copy_artist_contacts_to_travel_contacts',
    calendar_date_id,
  }),
  
  findFlightInfo: ({
    airCode,
    flightCode,
    year,
    month,
    day
  }) => HttpClient.post(TRAVEL_URL, {
    air_code: airCode,
    flight_code: flightCode,
    section: BOOKINGS_STRING,
    action: GET_FLIGHT_INFO,
    year: year,
    month: month,
    day: day
  }),
  insertTravel: (travel = createTravel(), calendarDateId) => {
    return HttpClient.post(BOOKING_URL, {
      section: BOOKINGS_STRING,
      action: ADD_REMOVE_TRAVEL_STEP,
      date1: travel.dateOrigin,
      time1: travel.timeOrigin,
      city1: travel.origin,
      date2: travel.dateArrival,
      time2: travel.timeArrival,
      city2: travel.arrival,
      travel_type: travel.type,
      carrier: travel.carrier,
      travel_no: travel.travelNo,
      notes: travel.notes,
      travel_booking_date: travel.date,
      travel_agent: travel.travelAgent,
      costs: travel.travelCosts,
      staff_id: travel.staffId,
      code1: travel.originCode,
      code2: travel.arrivalCode,
      after_gig_flag: (travel.afterGigFlag == '1' ? travel.afterGigFlag : ''),
      calendar_date_id: calendarDateId,
      contacts: travel.contacts,
      filekeys: travel.fileKeys,
      etickets: travel.eTickets,
    });
  },
  removeTravel: (
    travelId,
    calendarDateId
  ) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: REMOVE_TRAVEL_STEP,
    travel_id: travelId,
    calendar_date_id: calendarDateId
  }),
  findTravelDetails: ({
    calendarDateId,
    options
  }) => HttpClient.get2(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: CALENDAR_BOOKINGS_TRAVEL_DETAILS,
    calendar_date_id: calendarDateId
  }, options),
  updateTravel: (
    travelId,
    value,
    name
  ) => HttpClient.modify(
    TRAVEL_ID_STRING,
    travelId,
    name,
    value,
    TRAVELS_STRING,
  ),
  updateTravelCost: (
    travelId,
    value
  ) => HttpClient.modify(
    TRAVEL_ID_STRING,
    travelId,
    COSTS_STRING,
    value,
    TRAVELS_STRING,
  ),
  updateConfirmedFlag: (
    travelId,
    value
  ) => HttpClient.modify(
    TRAVEL_ID_STRING,
    travelId,
    CONFIRMED_FLAG,
    value,
    TRAVELS_STRING
  ),
  findTravelDescription: ({
    calendarDateId,
    travelId
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: TRAVEL_STEP_FORM,
    calendar_date_id: calendarDateId,
    travel_id: travelId,
    output: JSON_STRING
  }),
  updateTravelAfterGigFlag: ({
    travel_id,
    calendar_date_id,
    after_gig_flag = 0,
  } = {}) => {
    return MHTTPCL.post(BOOKING_URL, {
      section: 'bookings',
      action: 'change_travel_step',
      travel_id,
      calendar_date_id,
      after_gig_flag,
    })
  },
  findAddTravelData: ({
    calendarDateId,
    after_gig_flag,
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: TRAVEL_STEP_FORM,
    calendar_date_id: calendarDateId,
    after_gig_flag: after_gig_flag,
    output: JSON_STRING
  }),
  updateTravelContacts: ({
    calendarDateId,
    travelId,
    contacts,
    filekeys,
    etickets
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: ADD_REMOVE_TRAVEL_STEP_CONTACTS,
    calendar_date_id: calendarDateId,
    travel_id: travelId,
    contacts: contacts,
    filekeys: filekeys,
    etickets: etickets,
  }),
  updateTravelFull: ({
    travelId,
    travel = createTravel(),
    calendarDateId
  }) => HttpClient.post(MODIFICATION_URL, {
    modify_type: RECORD_STRING,
    table: TRAVELS_STRING,
    kVal: travelId,

    date1: travel.dateOrigin,
    time1: travel.timeOrigin,
    city1: travel.origin,
    date2: travel.dateArrival,
    time2: travel.timeArrival,
    city2: travel.arrival,
    travel_type: travel.type,
    carrier: travel.carrier,
    travel_no: travel.travelNo,
    notes: travel.notes,
    travel_booking_date: travel.date,
    travel_agent: travel.travelAgent,
    costs: travel.travelCosts,
    staff_id: travel.staffId,
    code1: travel.originCode,
    code2: travel.arrivalCode,
    calendar_date_id: travel.calendar_date_id,
    calendar_date_id_out: travel.calendar_date_id_out,
    after_gig_flag: (travel.afterGigFlag == '1' ? travel.afterGigFlag : ''),
  }),

  setDefaultTravelDetails: ({
    travels,
    calendar_date_id,
    from,
  }) => MHTTPCL.post(BOOKING_URL, {
    section: 'bookings',
    action: 'set_default_travel_details',
    travels,
    calendar_date_id,
    from,
  })
};